import { Box, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import { useActions } from 'ActionsContext';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Action } from '../../models/Action';
import { StyledButton } from '../styles/StyledButtons';
import StyledSection from '../styles/StyledSection';
import { StyledHeading, StyledTypography } from '../styles/styles';

export default function ActionsPage() {
  console.log('ActionsPage component starting to render');

  const navigate = useNavigate();
  const { unresolvedActions, loading } = useActions();

  console.log(
    'ActionsPage render - loading():',
    loading(),
    'unresolvedActions:',
    unresolvedActions(['investment-entity-association'])?.length,
    'placeholder-contact:',
    unresolvedActions(['placeholder-contact'])?.length,
  );

  if (loading()) {
    console.log('ActionsPage - showing loading spinner');
    return <CircularProgress />;
  }

  console.log('ActionsPage - showing content');

  const handleAssociateEntity = (link: string) => {
    navigate(link);
  };

  const allActions = [
    ...(unresolvedActions(['investment-entity-association']) || []),
    ...(unresolvedActions(['placeholder-contact']) || []),
    ...(unresolvedActions(['content-review']) || []),
    ...(unresolvedActions(['expired-email-change']) || []),
    ...(unresolvedActions(['rejected-email-change']) || []),
  ];

  return (
    <StyledSection tone="tone1">
      <StyledHeading tone="tone1">Actions</StyledHeading>
      {!allActions.length ? (
        <Card sx={{ p: 3, textAlign: 'center' }}>
          <CardContent>
            <Typography variant="h6" color="text.secondary">
              No unresolved actions
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {allActions.map((action: Action) => (
            <Card key={action.fulfillmentLink} sx={{ p: 2 }}>
              <CardContent
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'nowrap',
                  '&:last-child': { pb: 2 },
                }}
              >
                <Box sx={{ flex: 1, minWidth: 0, mr: 2 }}>
                  <StyledTypography tone="tone1">{action.name}</StyledTypography>
                </Box>
                <StyledButton
                  onClick={() => handleAssociateEntity(action.fulfillmentLink)}
                  variant="contained"
                  size="small"
                  sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                >
                  {action.resolutionAction}
                </StyledButton>
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </StyledSection>
  );
}
